<template>
  <div class="product-item">
    <bg-intro :bg="bg" class="bg-wrapper">
      <div class="apply-intro">
        <h2>北斗三号短报文智能卡</h2>
        <h2>办理/申请业务</h2>
      </div>
    </bg-intro>

    <div class="intro-wrapper">
      <h3>北斗三号短报文智能卡办理/申请业务</h3>
      <div class="intro-content content_wrapper space-between">
        <div class="intro-detail">
          <p class="intro">
            北斗短报文通讯不依赖传统的移动联通电信通讯信号，在弱信号、无信号等通信信号的恶劣的环境中，北斗短报文通信功能显得尤为重要。比如在山区、海洋、沙漠等没有通讯信号和网络的地方，或者在国防、民生和应急救援等领域，都具有很强的应用价值。
          </p>
          <p class="intro">
            在灾区移动通讯中断、电力中断或移动通信无法覆盖的情况下，可以通过安装北斗短报文模块的移动设备，查看自己的位置，并能够向外界发布带位置的文字信息。现北斗短报文已被广泛用于紧急救援、野外作业、户外数传、海上作业系统等领域中。
          </p>
          <p class="intro">
            北斗三号短报文智能卡是卫星导航RNSS应用管理中心统一管理的，北斗短报文终端配备北斗数据服务后，才能使用北斗短报文服务。目前北斗三号短报文智能卡入网对象为国内军队、国企、事业单位等组织，使用范围为国土范围，不得在国外使用。
          </p>
          <div class="sub-intro">
            <p>申请条件：使用对象是国内国企、事业单位、学校等组织；</p>
            <p>办理时间：提交申请后10-35工作日；</p>
            <p>使用范围：国土范围内；</p>
            <p class="fee">收费标准：申请费****元/张 ，通信费**元/月/卡（询客服）；</p>
            <p>其他说明：北斗卡补办/注销/绑定隶属关系/项目合作询价等请联系销售客服；</p>
            <p>北斗卡的频度和通信容量、批复时间以中国卫星导航定位应用管理中心批复为准；</p>
          </div>
        </div>

        <img src="../../assets/product/bdk1.webp" alt="北斗卫星导航系统" />
      </div>
    </div>

    <div class="apply-type">
      <h3>
        可申请
        <b>北斗卡</b>
        的类型
      </h3>
      <!-- <div class="apply-wrapper content_wrapper space-around">
        <div class="apply-item">
          <img src="../../assets/product/ptts.webp" alt="北斗卡" />
          <p class="title">北斗民用智能卡</p>
          <p class="frequency">通信频度：30秒/60秒/300秒/条</p>
          <p class="capacity">通信容量：78字节/条</p>
        </div>

        <div class="apply-item">
          <img src="../../assets/product/zxts.webp" alt="北斗卡" />
          <p class="title">北斗指挥卡（通播/监听/监收）</p>
          <p class="frequency">通信频度：50秒/条</p>
          <p class="capacity">通信容量：105字节/条</p>
        </div>
      </div> -->
      <!-- <div class="card-wrapper content_wrapper space-between">
        <div class="card-item">
          <img src="../../assets/product/left-card.png" alt="" />
          <p>双向卡样式示例</p>
        </div>
        <div class="card-item">
          <img src="../../assets/product/right-card.png" alt="" />
          <p>单向卡样式示例</p>
        </div>
      </div> -->

      <div class="table-compare">
        <div class="tg-wrap content_wrapper">
          <div class="table-content">
            <p>表1 北斗三号双向卡和单向卡的区别说明</p>
            <div class="img-wrapper">
              <img src="../../assets/product/table1.png" alt="" />
            </div>
          </div>
        </div>

        <div class="table2 content_wrapper">
          <div class="table-content">
            <p>通信等级(汉字长度): 是指北斗终端入站短报文信息长度的上限划分等级，详见下表：</p>
            <p class="title">表2 区域短报文通信等级及电文长度说明</p>
            <div class="img-wrapper">
              <img src="../../assets/product/table2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-container">
      <h3>北斗三号短报文智能卡入网表单填写</h3>

      <div class="form-content">
        <el-form :model="form" :rules="custom" ref="custom" label-position="top">
          <el-form-item label="业务类型" prop="businessType">
            <el-radio-group v-model="form.businessType">
              <el-radio label="CIVIL_CARD_REG">双向卡业务</el-radio>
              <el-radio label="COMMAND_CARD_REG">单向卡业务</el-radio>
              <el-radio label="CHANGE_AFFILIATION">隶属关系更改</el-radio>
              <el-radio label="MAKE_UP">北斗卡补办</el-radio>
              <el-radio label="CANCEL">北斗卡注销</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="增值服务" prop="valueAddedService">
            <el-radio-group v-model="form.valueAddedService">
              <el-radio label="BD_MSG_RECEIPT">短报文回执</el-radio>
              <el-radio label="DEDICATED_LINE_PUSH">专线数据推送</el-radio>
              <el-radio label="MANAGEMENT_ACCOUNT">企业管理账号</el-radio>
              <el-radio label="BD_RECEIVE_CHANNEL">北斗接收通道</el-radio>
              <el-radio label="BD_MSG_SEND">报文下发</el-radio>
              <el-radio label="MSG_SMS_INTER_FLOW">报文和短信互通</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="联系姓名" prop="fullName">
            <el-input v-model="form.fullName" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入您的单位名称"></el-input>
          </el-form-item>
          <el-form-item label="联络电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的联系电话或者直接联系网站底部客服"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper">
          <button @click="submitCustom">提 交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgIntro from '@/components/common/product/bgIntro.vue';
import { validatePhone, validateFullName, validateCompany } from '@/utils/validate';
import axios from 'axios';
import config from '../../config';
export default {
  inject: ['reload'],
  metaInfo: {
    title: '北斗民用智能卡办理/申请业务',
    meta: [
      {
        name: 'keywords',
        content: '申请北斗卡,办理北斗民用卡,申请北斗指挥卡,采购北斗卡',
      },
      {
        name: 'description',
        content:
          '北斗民用智能是卫星导航RNSS应用管理中心统一管理的，北斗短报文终端配备北斗数据服务后，才能使用北斗短报文服务。申请条件：使用对象是国内国企、事业单位、学校等组织；办理时间：提交申请后20-60工作日；使用范围：国土范围内；收费标准：申请费****元/张 ，通信费**元/月/卡（询客服）；',
      },
    ],
  },
  data() {
    return {
      bg: require('../../assets/product/bdk-banner.webp'),
      form: {
        businessType: 'CIVIL_CARD_REG',
        valueAddedService: 'BD_MSG_RECEIPT',
        fullName: '',
        phone: '',
        companyName: '',
      },
      custom: {
        businessType: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],
        valueAddedService: [{ required: true, message: '请选择增值服务', trigger: 'blur' }],
        fullName: [{ required: true, trigger: 'blur', validator: validateFullName }],
        companyName: [{ required: true, trigger: 'blur', validator: validateCompany }],
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
      },
    };
  },
  methods: {
    submitCustom() {
      this.$refs.custom.validate(async (valid) => {
        if (valid) {
          try {
            const res = await axios({
              baseURL: config.baseUrl,
              url: '/api/console/forms/bd-card-application',
              method: 'post',
              params: {
                Authorization: '1213',
                ...this.form,
              },
            });
            console.log(res);
            if (res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '提交成功',
              });
              this.reload();
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  components: {
    bgIntro,
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  width: 100%;
  .intro-wrapper {
    box-sizing: border-box;
    padding: 70px 0px;
    background-color: #fff;
    h3 {
      text-align: center;
      margin-bottom: 70px;
    }
    .intro-content {
      .intro-detail {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 35px;
        margin-right: 90px;
        .intro {
          text-indent: 30px;
        }
        .sub-intro {
          margin-top: 40px;
          text-indent: 30px;
          .fee {
            color: #226bfb;
          }
        }
      }
    }
  }
  .apply-type {
    padding: 70px 0px;
    background: #f6f7f8;
    h3 {
      text-align: center;
      margin-bottom: 60px;
    }
    .apply-item {
      box-sizing: border-box;
      text-align: center;
      // width: 45%;
      background-color: #fff;
      padding: 75px;

      .title {
        font-size: 20px;
        font-weight: 400;
        color: #0d0e24;
        line-height: 40px;
        margin-top: 40px;
      }
      .frequency {
        font-size: 20px;
        font-weight: 400;
        color: #226bfb;
        line-height: 40px;
      }

      .capacity {
        font-size: 18px;
        font-weight: 300;
        color: #0d0e24;
        line-height: 40px;
      }
    }
    .card-wrapper {
      margin-bottom: 20px;
      .card-item {
        text-align: center;
      }
    }
  }
  .form-container {
    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-top: 50px;
      margin-bottom: 50px;
    }
    width: 1000px;
    margin: 0 auto;
    .form-content {
      width: 800px;
      margin: 0 auto;
      &::v-deep {
        .el-form-item__label {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
      .btn-wrapper {
        text-align: left;
        margin-top: 60px;
        margin-bottom: 60px;
        button {
          width: 256px;
          height: 46px;
          background: #4173fb;
          border-radius: 4px;
          cursor: pointer;
          outline: none;
          border: none;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}

.table-compare {
  width: 100%;
  .tg-wrap {
    font-weight: 400;
    margin-bottom: 20px;
    p {
      margin-bottom: 12px;
      width: 100%;
    }
  }
  .table2 {
    .title {
      margin-top: 12px;
    }
  }

  .table-content{
    width: 75%;
    margin: 0 auto;
  }
  .img-wrapper {
    img {
      width: 100%;
    }
  }
}
</style>